import store from '@/store';
import { AxiosResponseInterceptor } from '@/models/base/AxiosResponseInterceptor';
import router from '@/router';
import axios from 'axios';
import AuthorizationService from '@/services/authorization.service';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { REFRESH_TOKEN, SET_TOKENS } from '@/types/authorization.types';

export const sessionApiService = new AuthorizationService();

/* tslint:disable:no-let */
let isRefreshing = false;
let failedQueue: any = [];
/* tslint:enable:no-let */

const processQueue = (error, token): any => {
  failedQueue.forEach(promise => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });

  failedQueue = [];
};

export const sessionRecoveryInterceptor: AxiosResponseInterceptor = {
  onFulFilled: (config: any) => config,
  onError: (error: any) => {
    const originalRequest = error.config;
    const refreshToken = store.getters[`${StoreNamespace.AUTHORIZATION_MODULE}/${REFRESH_TOKEN}`];
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      // Logic to prevent double requests to refreshToken endpoint
      // when we have multiple parallel requests that return 401.
      if (isRefreshing) {
        return new Promise((resolve: any, reject: any): void => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers[`Authorization`] = `Bearer ${token}`;

          return axios(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve: any, reject: any): void => {
        sessionApiService.refreshToken(refreshToken)
          .subscribe(
            (data) => {
              store.commit(`${StoreNamespace.AUTHORIZATION_MODULE}/${SET_TOKENS}`,
                { accessToken: data.accessToken, refreshToken: data.refreshToken });
              originalRequest.headers[`Authorization`] = `Bearer ${data.accessToken}`;
              processQueue(null, data.accessToken);

              resolve(axios(originalRequest));
            },
            (err) => {
              processQueue(err, null);
              router.push({ name: 'login' });

              reject(err);
            },
            () => isRefreshing = false,
          );
      });
    }

    return Promise.reject(error);
  },
};
